import React, {useEffect} from 'react';
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ConfirmationDialog from "../ConfirmationDialog";
import {eventStatus} from "../../util/standards-util";
import {useUpdateEventSetupMutation} from "../../slices/apiSlice";
import {useDispatch} from "react-redux";
import {setEvent, setEventRules} from "../../slices/sessionSlice";

const EventRegistrationStatusWidget = ({ event }) => {
    const [mode, setMode] = React.useState('button')

    const dispatch = useDispatch()
    const [updateEvent, updateEventResult] = useUpdateEventSetupMutation()


    const handleChangeStatusClicked = () => {
        setMode('confirm')
    }

    const handleConfirmClosed = (confirmed)=> {
        if (confirmed){
            const status = event.status === eventStatus.STATUS_PLANNED ? eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED : eventStatus.STATUS_PLANNED
            updateEvent({
                id: event.id,
                status:status,
            })
            setMode('button')
        }
        else {
            setMode('button')
        }
    }

    useEffect(() => {
        if (updateEventResult.isSuccess) {
            console.log(updateEventResult.data)
            if (updateEventResult.data.status === 'ok') {
                dispatch(setEvent(updateEventResult.data.event))
                dispatch(setEventRules(updateEventResult.data.rules))
            }
        }
    }, [updateEventResult]);

    return (
        <>
            {mode === 'button' &&
                <Button variant={'contained'} onClick={handleChangeStatusClicked}>{event.status === eventStatus.STATUS_PLANNED ? 'Close registration' : 'Reopen registration'}</Button>
            }
            {mode === 'confirm' && event.status === eventStatus.STATUS_PLANNED &&
                <ConfirmationDialog title={'Pilot registration'} body={
                    <>
                        <Box>Are you sure you would like to close pilot registration</Box>
                        <Box>Additional pilots will not be able to register after registration is closed</Box>
                    </>
                }
                                    onCancel={() => handleConfirmClosed(false)}
                                    onConfirm={() => {handleConfirmClosed(true)}}
                                    confirmText='OK'
                />
            }
            {mode === 'confirm' && event.status === eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED &&
                <ConfirmationDialog title={'Pilot registration'} body={
                    <>
                    <Box>Are you sure you would like to reopen pilot registration?</Box>
                    <Box>This will allow additional pilots to register to the event</Box>
                    </>
                }
                onCancel={() => handleConfirmClosed(false)}
                onConfirm={() => {handleConfirmClosed(true)}}
                confirmText='OK'
                />
            }
        </>
    )
}

export default EventRegistrationStatusWidget;